import { Icon, notification, theme } from "@findemdev/maui";
import { MouseEvent, useCallback, useState } from "react";
import { decodeString } from "@findemdev/findem-helpers";
// types
import { CredRef, ICredential } from "../../../types/credential";
// stlyed components + components
import { FavoriteButton, FavoriteButtonWrapper, FavoriteColumnWrapper } from "../Credentials.styled";
import { EditDetailsModal } from "./CredentialsTable";
import Action from "./Action";
// custom hooks
import { useToggleFavoriteCredentialMutation } from "../../../../../services/matches";
import useGetCredentialJoid from "../../../hooks/useGetCredentialJoid";
import { TabId } from "../NavigationTabs";

interface IFavoriteProps {
  credential: ICredential;
  activeTab: TabId;
  setDeleteCredModal: React.Dispatch<React.SetStateAction<{
    show: boolean;
    credRef: CredRef | null;
  }>>;
  setEditDetailsModal: React.Dispatch<React.SetStateAction<EditDetailsModal>>;
  setCopyCredModal: React.Dispatch<React.SetStateAction<{
    show: boolean;
    newCredName: string;
    credential: ICredential | null;
  }>>;
  setMarqueeCredModal: React.Dispatch<React.SetStateAction<{
    show: boolean;
    credential: ICredential | null;
  }>>;
}

const Favorite = ({
  credential,
  activeTab,
  setDeleteCredModal,
  setEditDetailsModal,
  setCopyCredModal,
  setMarqueeCredModal,
}: IFavoriteProps) => {

  // context user
  const credentialJoid = useGetCredentialJoid({});

  // api
  const [toggleFavoriteCred] = useToggleFavoriteCredentialMutation({
    fixedCacheKey: "favorite-toggle-creds-list"
  });

  const [isFavoriteButtonHovered, setIsFavoriteButtonHovered] = useState<boolean>(false);


  // callback
  const handleToggleFavorite = useCallback((event: MouseEvent<HTMLButtonElement>) => {
    const decodedCredentialName = decodeString(credential.name);

    try {
      event.stopPropagation();

      toggleFavoriteCred({
        ref: credential.ref,
        joid: credentialJoid,
      });

    } catch {
      console.error(`Error while marking credential: ${credential.ref} toggle favorite`);
      notification.error({
        message: `Failed to update the favorite status for ${decodedCredentialName}.`
      });
    }

  }, [credential, credentialJoid]);

  const handleMouseEnterFavoriteButton = useCallback(() => {
      setIsFavoriteButtonHovered(true);
    }, []);

    const handleMouseLeaveFavoriteButton = useCallback(( ) => {
      setIsFavoriteButtonHovered(false);
    }, []);

  return <FavoriteColumnWrapper>
    <FavoriteButtonWrapper>
      <FavoriteButton
        onClick={handleToggleFavorite}
        data-key="favorite"
        onMouseEnter={handleMouseEnterFavoriteButton}
        onMouseLeave={handleMouseLeaveFavoriteButton}
      >
        <Icon
          icon={"grade"}
          $size={18}
          $color={theme.colors["grey-600"]}
          type={credential?.favorite_marked_by?.includes(credentialJoid) || isFavoriteButtonHovered ? "round" : "outlined"}
        />
      </FavoriteButton>
    </FavoriteButtonWrapper>
    <Action
      setDeleteCredModal={setDeleteCredModal}
      setEditDetailsModal={setEditDetailsModal}
      setCopyCredModal={setCopyCredModal}
      setMarqueeCredModal={setMarqueeCredModal}
      credRef={credential.ref}
      credential={credential}
      activeTab={activeTab}
    />
  </FavoriteColumnWrapper>
};

export default Favorite;
